// @ts-check
import { api } from "../client.js";

/** Endpoints das jornadas de automação. */
export const automationsApi = {
  list: () => api.get("/automations"),

  /** @param {string} id */
  find: (id) => api.get(`/automations/${id}`),

  /** @param {object} dados */
  create: (dados) => api.post("/automations", dados),

  /** @param {string} id @param {object} patch */
  update: (id, patch) => api.patch(`/automations/${id}`, patch),

  /** @param {string} id */
  remove: (id) => api.delete(`/automations/${id}`),

  /** @param {string} id @param {object} dados */
  addStep: (id, dados) => api.post(`/automations/${id}/steps`, dados),

  /** @param {string} id @param {string} stepId @param {object} patch */
  updateStep: (id, stepId, patch) => api.patch(`/automations/${id}/steps/${stepId}`, patch),

  /** @param {string} id @param {string} stepId */
  removeStep: (id, stepId) => api.delete(`/automations/${id}/steps/${stepId}`),

  /** @param {string} id @param {string[]} stepIds */
  reorderSteps: (id, stepIds) => api.patch(`/automations/${id}/steps-order`, { stepIds }),
};
